export default [
  { to: 'allmant', title: 'Allmänt' },
  { to: 'rutiner', title: 'Rutiner' },
  { to: 'internt', title: 'Internt' },
];
